import {
  HOME_QUICK_LINKS,
  HOME_QUICK_LINK_CLICK,
} from '../../constants/endpoints';
import request from '../request';

export interface HomeQuickLink {
  key: string;
  label: string;
  icon: string;
  href: {
    learner: string;
    educator: string;
  };
}

export interface HomeQuickLinksResponse {
  quickLinks: HomeQuickLink[];
}

export const fetchHomeQuickLinks = async (
  role: string
): Promise<HomeQuickLinksResponse> => {
  const { data } = await request({
    method: 'get',
    url: HOME_QUICK_LINKS(role),
  });
  return data as HomeQuickLinksResponse;
};

export const patchQuickLinkClick = async (
  linkKey: string,
  role: string
): Promise<void> => {
  await request({
    method: 'patch',
    url: HOME_QUICK_LINK_CLICK(linkKey, role),
  });
};
